import styled from 'styled-components';

export const StyledKakarikoEditingCell = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
`;
